

































import { Component, Vue, Model } from "vue-property-decorator";

import { ObjectiveFunctionParameters } from "@/data/models/SchedulingSettings";

@Component
export default class ObjectiveFunctionParametersComponent extends Vue {
  @Model("change")
  objectiveFunctionParameters!: ObjectiveFunctionParameters;

  weightGroups = [
    ["total", "travelTime", "timeGap"],
    ["targetDate", "targetDateFixed", "targetTime", "targetTimeFixed"],
    [
      "targetUser",
      "targetQualification",

      "dailyWorkTimeExceedance",
      "weeklyWorkTimeExceedance",
    ],
  ];

  getWeight(
    weightName:
      | "total"
      | "travelTime"
      | "timeGap"
      | "targetDate"
      | "targetDateFixed"
      | "targetTime"
      | "targetTimeFixed"
      | "targetUser"
      | "targetQualification"
      | "dailyWorkTimeExceedance"
      | "weeklyWorkTimeExceedance"
  ) {
    return this.objectiveFunctionParameters.weights[weightName];
  }

  setWeight(
    weightName:
      | "total"
      | "travelTime"
      | "timeGap"
      | "targetDate"
      | "targetDateFixed"
      | "targetTime"
      | "targetTimeFixed"
      | "targetUser"
      | "targetQualification"
      | "dailyWorkTimeExceedance"
      | "weeklyWorkTimeExceedance",
    value: number
  ) {
    this.updateObjectiveFunctionParameters(
      (objectiveFunctionParameters) =>
        (objectiveFunctionParameters.weights[weightName] = value)
    );
  }

  localiseWeight(
    weightName:
      | "total"
      | "travelTime"
      | "timeGap"
      | "targetDate"
      | "targetDateFixed"
      | "targetTime"
      | "targetTimeFixed"
      | "targetUser"
      | "targetQualification"
      | "dailyWorkTimeExceedance"
      | "weeklyWorkTimeExceedance"
  ) {
    return this.$t(
      `settings.scheduling.objectiveFunctionParameters.weights.${weightName}`
    );
  }

  updateObjectiveFunctionParameters(
    callback: (objectiveFunctionParameters: ObjectiveFunctionParameters) => void
  ) {
    const currentValue = this.objectiveFunctionParameters;
    callback(currentValue);

    const update = {
      ...currentValue,
    };

    this.$emit("change", update);
  }
}
